// Import DevExtreme and DevExteme-intl
import { DevExtremeModule } from 'devextreme-angular';
import 'devextreme-intl';
import { locale, loadMessages } from 'devextreme/localization';

import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { CustomFormsModule } from 'ng2-validation';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { LocalStorageModule } from 'angular-2-local-storage';
import { OAuthModule } from 'angular-oauth2-oidc';

import { CoreModule } from './core/core.module';

import { AppComponent } from './app.component';

import { AppRoutingModule } from './app-routing.module';

import { APP_INITIALIZER } from '@angular/core';
import { ConfigService } from './config.service';

export function initializeApp(configService: ConfigService) {
  return () => configService.load();
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, `${ConfigService.app.baseUri}/i18n/apps_bar/`, '');
}

loadMessages(require('../assets/devextreme-messages/es.json'));
loadMessages(require('../assets/devextreme-messages/pt.json'));

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    CustomFormsModule,
    LocalStorageModule.withConfig({
      prefix: 'ri',
      storageType: 'localStorage'
    }),
    TranslateModule.forRoot({
        loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient]
        },
        isolate: false
    }),

    CoreModule.forRoot(),
    OAuthModule.forRoot(),

    AppRoutingModule,
    DevExtremeModule
  ],
  providers: [
    ConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [ConfigService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts